<template>
<div class="schedule-editor">
     <div class='date-time'>
        <label>Alkaa</label>
        <b-form-datepicker placeholder="Tänään" :date-format-options="{ weekday: 'short' }" :start-weekday="1" :disabled="disabled"></b-form-datepicker>
        <b-form-timepicker :placeholder="getValidityStartTime()" :disabled="disabled"></b-form-timepicker>  
    </div>
    <div class='date-time'>
        <label>Loppuu</label>
        <b-form-datepicker placeholder="Tänään" :date-format-options="{ weekday: 'short' }" :start-weekday="1" :disabled="disabled"></b-form-datepicker>
        <b-form-timepicker :placeholder="getValidityEndTime()" :disabled="disabled"></b-form-timepicker>  
    </div>
    
    <div :key="scheduleKey">
        <div v-for="i in scheduleCount" :key="i" class="schedule">
            <div class='date-time'>
            <label>Päivät</label>
                <b-badge href="#" :class="{ selected: isSelected(i, 1) }" @click="selectDay(i, 1)">Ma</b-badge>
                <b-badge href="#" :class="{ selected: isSelected(i, 2) }" @click="selectDay(i, 2)">Ti</b-badge>
                <b-badge href="#" :class="{ selected: isSelected(i, 3) }" @click="selectDay(i, 3)">Ke</b-badge>
                <b-badge href="#" :class="{ selected: isSelected(i, 4) }" @click="selectDay(i, 4)">To</b-badge>
                <b-badge href="#" :class="{ selected: isSelected(i, 5) }" @click="selectDay(i, 5)">Pe</b-badge>
                <b-badge href="#" :class="{ selected: isSelected(i, 6) }" @click="selectDay(i, 6)">La</b-badge>
                <b-badge href="#" :class="{ selected: isSelected(i, 7) }" @click="selectDay(i, 7)">Su</b-badge>
                <b-badge href="#" class='x' @click="removeDaySelections(i)"><span class='x'>x</span></b-badge>
            </div>
            <div class='date-time'>
                <label>Esitysaika</label>
                <b-form-timepicker value="00:00" :disabled="disabled"></b-form-timepicker>
                <b-form-timepicker value="23:59" :disabled="disabled"></b-form-timepicker>
            </div>
        </div>
    </div>
    <t-button small type="add-icon" right title="Lisää esitysaika" @click="addSchedule()"></t-button>  
</div>
</template>


<script>
import Moment from "moment";

export default ({
     data: function() {
        return {
            disabled: false,    
            scheduleCount: 1,
            scheduleKey: 0,
            selectedDays: [ [1, 2, 3, 4, 5, 6, 7] ]
        }
    },
     methods: {
         getValidityStartTime(){
            let m = Moment();
            return "Nyt (" + m.format("HH:mm") + ")";
        },
        getValidityEndTime(){
            let m = Moment();
            m.add(30, 'minutes')
            return "+30 min (" + m.format("HH:mm") + ")";
        },
        isSelected(i, day){
            return this.selectedDays[i-1].includes(day);
        },
        selectDay(i, day){
            if(!this.selectedDays[i-1].includes(day) )
                this.selectedDays[i-1].push(day);
            else
                this.selectedDays[i-1] = this.selectedDays[i-1].filter(d => d != day);

             //this.$forceUpdate();
             this.scheduleKey++;

        },
        removeDaySelections(i){
            this.selectedDays[i-1] = [];
            this.scheduleKey++;
        },
        addSchedule(){
            this.selectedDays.push ( [1, 2, 3, 4, 5, 6, 7] );
            this.scheduleCount++;
        }
     }
})
</script>